// The brand comes from /brand.json, emitted from the brand pack at build time
// (ADR 0010). Nothing brand-specific is written in source code.
import { createContext, useContext, type ReactNode } from "react";
import type { Schemas } from "../../api/client";

export type PublicBrand = Schemas["PublicBrand"];

export async function fetchBrand(fetchImpl: typeof fetch = fetch): Promise<PublicBrand> {
  const res = await fetchImpl(`${import.meta.env.BASE_URL}brand.json`, { headers: { Accept: "application/json" } });
  if (!res.ok) throw new Error(`brand.json: HTTP ${res.status}`);
  return (await res.json()) as PublicBrand;
}

const BrandContext = createContext<PublicBrand | null>(null);

export function BrandProvider({ brand, children }: { brand: PublicBrand; children: ReactNode }) {
  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}

export function useBrand(): PublicBrand {
  const b = useContext(BrandContext);
  if (!b) throw new Error("useBrand outside BrandProvider");
  return b;
}

/** localised picks the text for lng, falling back to the brand default locale. */
export function localised(brand: PublicBrand, field: Record<string, string>, lng: string): string {
  return field[lng] ?? field[brand.default_locale] ?? "";
}
